import { useState } from 'react';

import { PrimeIcons } from 'primereact/api';
import { ConfirmDialog } from 'primereact/confirmdialog';
import { InputText } from 'primereact/inputtext';

import {
  useShippingAbcFormPartDExcelReport,
  useShippingAbcFormPartDReport,
} from '@/services/reports';
import type { ShipmentEmbryo } from '@/services/shipping/types';

import { useShipmentContext } from '../../hooks/useShipmentContext';

export function AbcFormDReportDialog({
  type,
  onClose: closeConfirmDialog,
  selectedEmbryos,
}: {
  type: 'pdf' | 'excel' | undefined;
  onClose(): void;
  selectedEmbryos: ShipmentEmbryo[];
}) {
  const { shipment } = useShipmentContext();
  const defaultCountry = shipment?.owner?.ranchAddress?.country || undefined;

  const [country, setCountry] = useState(defaultCountry);

  const [pdf] = useShippingAbcFormPartDReport();
  const [excel] = useShippingAbcFormPartDExcelReport();

  async function generate() {
    if (!selectedEmbryos.length || !type) {
      return;
    }

    try {
      const embryoIds = selectedEmbryos.map((e) => e.id);
      if (type === 'pdf') {
        await pdf({
          embryoIds,
          country,
        });
      } else {
        await excel({
          embryoIds,
          country,
        });
      }
    } catch (e) {
      console.error(e);
    }

    closeConfirmDialog();
  }

  return (
    <div
      onClick={(e) => e.stopPropagation()}
      onKeyDown={(e) => e.stopPropagation()}
    >
      <ConfirmDialog
        visible={!!type}
        onHide={() => closeConfirmDialog()}
        header="Confirm Country"
        message={
          <InputText
            name="country"
            className="m-2"
            placeholder="Country"
            autoFocus
            value={country}
            onChange={(e) => setCountry(e.target.value)}
          />
        }
        icon={PrimeIcons.QUESTION_CIRCLE}
        accept={generate}
        pt={{
          icon: { className: 'text-3xl' },
          acceptButton: {
            type: 'button',
          },
          rejectButton: { type: 'button' },
        }}
      />
    </div>
  );
}
